/* Packages */
import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';

/* Hooks */
import useFlowContext from "conversie-flow-bundle/assets/js/components/flow/hooks/useFlowContext";
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';


export default function FlowFieldSelect(props) {
    const { colClassName, field, path, id, updateValue } = props;
    const { type, label, choices, required, disabled, placeholder = null, value, name } = field;

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    const {
        translate = () => {},
    } = useFlowContext();

    const requiredText = translate(`webstores_conversion_flow.common.required_field`);

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                <div className="row gutters-2 align-items-lg-center">
                    <div className="col-12 col-lg-5">
                        {label && (
                            <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                        )}
                        {required === true && requiredText.length !== 0 &&
                            <span className="required-label">{requiredText}</span>
                        }
                    </div>
                    <div className="col-12 col-lg-7">
                        <Form.Control
                            as="select"
                            custom
                            className={`${error ? 'is-error' : ''}`}
                            name={id}
                            {...{
                                required,
                                disabled,
                            }}
                            value={value[0] || ''}
                            onChange={(e) => {
                                updateValue([choices?.find((choice) => `${choice.key}` === `${e.target.value}`)?.key], () => {
                                    trigger(path);
                                });
                            }}
                        >
                            {placeholder && (
                                <option value="">{placeholder}</option>
                            )}
                            {choices?.map((choice, choiceIndex) => {
                                return (
                                    <option key={choice.key} value={choice.key}>{choice.label}</option>
                                )
                            })}
                        </Form.Control>
                        {error && (
                            <Form.Control.Feedback type="invalid">
                                {error}
                            </Form.Control.Feedback>
                        )}
                    </div>
                </div>
            </Form.Group>
        </div>
    );
}
